
import {
    DataTableLocal,
    LoadingStatusEnum,
    EsriUrlProvider,
    ThematicDataParser,
    DataRow,
    ParserUtil,
    HttpUtil
} from "cartovista";

Object.defineProperty(EsriUrlProvider.prototype, "valuesUrlWithToken", {
      get: function() {
        return HttpUtil.buildUrlFromQueryParameters(this._baseUrl, {
          returnGeometry: !1,
          outFields: this._parameters.outFields,
          where: this._parameters.where,
          f: this._parameters.f,
          token: this._parameters.token,
        })
      },
      enumerable: !0
    })

export default class DataTableEsri extends DataTableLocal{
        constructor(e, config, join_id, postData){
            var datacolumns = [...[join_id], ..._.map(config.FIELDS, "ID")];
            var postData = _.assign({
                outFields: datacolumns.join(","),
                where: typeof config.QUERY_EXPRESSION != "undefined" ? config.QUERY_EXPRESSION : null,
                token: typeof C.APP_TOOLS.AUTH_SESSION != "undefined" ? C.APP_TOOLS.AUTH_SESSION.USER.TOKEN : "",
            }, postData);
            var urlProvider = new EsriUrlProvider(C.URLS.QUERY_LAYERS[config.DATATABLE_ID], postData, datacolumns);
            urlProvider._parameters.f = "json";
            urlProvider._parameters.returnGeometry = false;
            super(e, urlProvider.valuesUrlWithToken, "JSON");
            this.urlProvider = urlProvider;
            this.join_id = join_id;
            window.cartovista.addOneTimeEventListener("AuthSession_UserLoggedIn", this._onUserLoggedIn, this);
        }

        _onUserLoggedIn(){
          this.urlProvider._parameters.token = typeof C.APP_TOOLS.AUTH_SESSION != "undefined" ? C.APP_TOOLS.AUTH_SESSION.USER.TOKEN : "";
          this.src = this.urlProvider.valuesUrlWithToken;
          this.load();
          window.cartovista.addOneTimeEventListener("AuthSession_UserLoggedOut", this._onUserLoggedOut, this);
        }

        _onUserLoggedOut(){
          this.urlProvider._parameters.token = "";
          this.src = this.urlProvider.valuesUrlWithToken;
          window.cartovista.addOneTimeEventListener("AuthSession_UserLoggedIn", this._onUserLoggedIn, this);
        }

        _onJSONLoaded(e, t) {
                  for (var i = new ThematicDataParser, n = this._columns, r = n.length, o = [], a = [], s = [], l = 0; l < r; l++)
                      o.push(n[l].id),
                      a.push(n[l].dataType),
                      s.push(n[l].sourceDateFormat);
                  this.addDataRows(this.parseRowsJson(e, a, s)),
                  this.loadingStatus = LoadingStatusEnum.READY,
                  this._executeCallbacks()

        };
        parseRowsJson(e, t, i) {
          i = i || [];
          for (var n = [], r = e.features.length, o = 0; o < r; o++) {
              var a = e.features[o];
              if (void 0 === a.attributes[this.join_id] || null === a.attributes[this.join_id])
                  throw new Error("Row id is mandatory");
              var l = new DataRow(a.attributes[this.join_id])
                , u = [];
            delete a.attributes[this.join_id]; 
              if (a.attributes){
                var entries = Object.entries(a.attributes);
                  for (var d = entries.length, h = 0; h < d; h++) {
                      var p = entries[h];
                      null == p[1] ? u.push(null) : u.push(ParserUtil.parseValue(t[h], p[1], i[h]))
                  }
                }
              else
                  for (var f = t.length - 1; f >= 0; f--)
                      u.push(null);
              l.dataValues = u,
              n[o] = l
          }
          return n
      };
    }